export const candidateSearchViewSelector = state => state.candidateSearchViewInfo;